<p-tabView
  [activeIndex]="activeSubComponent"
  (onChange)="onTabActivated($event)"
  styleClass="bfx-tabview"
>
  <p-tabPanel header="Preferences" styleClass="user-settings-tab-panel">
    <bfx-order-entry-settings-preferences #subComponent> </bfx-order-entry-settings-preferences>
  </p-tabPanel>
  <p-tabPanel
    header="Entry Defaults"
    class="order_entry_defaults_tab_panel"
    styleClass="user-settings-tab-panel"
    *ngIf="ROLE_VIEW_ORDER_ENTRY"
    fxLayout="row"
    fxLayoutGap="10px"
  >
    <div
      class="user-settings__order-entry__header-row"
      fxFlex="1 1 100%"
      fxLayout="row"
      fxLayoutGap="5px"
    >
      <div class="user-settings__order-entry__header-title" fxFlex="1 1 50%">Order Entry Type:</div>
      <div fxFlex="1 1 50%" class="user-settings__order-entry__header-selection">
        <!--       <p-dropdown
                    [options]="entryType.dataset"
                    [(ngModel)]="entryType.value"
                    [disabled]="entryType.disabled"
                    (onChange)="entryTypeChange($event)"
                    autoWidth="false"
                    class="user-settings__order-entry__entry-type-dropdown">
                </p-dropdown> -->
        <bfx-autoComplete
          #inputEntryType
          appendTo="body"
          size="sm"
          id="defaults_entry-type"
          inputId="defaults_entry-type"
          class="user-settings__order-entry__entry-type-autocomplete"
          [(ngModel)]="entryType.value"
          [label]=""
          [suggestions]="entryType.suggestions"
          [settingsCorrection]="true"
          [disabled]="entryType.disabled"
          [autoHighlight]="true"
          [skipSorting]="true"
          delay="4"
          field="label"
          dataKey="value"
          [dropdown]="true"
          [readonly]="true"
          (onChange)="entryTypeChange($event)"
          (onBlur)="entryTypeChange($event)"
          (completeMethod)="entryTypeSearch($event)"
          dropdownMenuClass="user-settings__order-entry__entry-type-autocomplete__dd"
        >
        </bfx-autoComplete>
      </div>
    </div>

    <!-- ALGO NDF Defaults-->
    <div
      fxFlex="1 1 100%"
      [style.display]="!entryType.disabled && (entryType.value != null && entryType.value.value === 'ndfalgo') ? 'inherit' : 'none'"
    >
      <bfx-order-entry-settings-ndf-algo #subComponent> </bfx-order-entry-settings-ndf-algo>
    </div>
    <!-- ALGO Defaults-->
    <div
      fxFlex="1 1 100%"
      [style.display]="!entryType.disabled && (entryType.value != null && entryType.value.value === 'algo') ? 'inherit' : 'none'"
    >
      <bfx-order-entry-settings-algo #subComponent> </bfx-order-entry-settings-algo>
    </div>
    <!-- NDF Defaults-->
    <div
      fxFlex="1 1 100%"
      [style.display]="!entryType.disabled && (entryType.value != null && entryType.value.value === 'ndf') ? 'inherit' : 'none'"
    >
      <bfx-order-entry-settings-ndf #subComponent> </bfx-order-entry-settings-ndf>
    </div>
    <!-- SPOT Defaults-->
    <div
      fxFlex="1 1 100%"
      [style.display]="!entryType.disabled && (entryType.value == null || entryType.value.value === 'spot') ? 'inherit' : 'none' "
    >
      <bfx-order-entry-settings-spot #subComponent> </bfx-order-entry-settings-spot>
    </div>

    <!-- Benchmark Defaults-->
    <div
      fxFlex="1 1 100%"
      [style.display]="!entryType.disabled && (entryType.value != null && entryType.value.value === 'bmark') ? 'inherit' : 'none'"
    >
      <bfx-order-entry-settings-bmark #subComponent> </bfx-order-entry-settings-bmark>
    </div>

    <!-- Gamma Defaults -->
    <div
      fxFlex="1 1 100%"
      [style.display]="!entryType.disabled && (entryType.value == null || entryType.value.value === 'gamma') ? 'inherit' : 'none' "
    >
      <bfx-order-entry-settings-gamma #subComponent> </bfx-order-entry-settings-gamma>
    </div>
  </p-tabPanel>
</p-tabView>
